__turbopack_context__.v({
  "Usp": "_0A3-IG_Usp",
  "UspBlock": "_0A3-IG_UspBlock",
  "Usp__arrow": "_0A3-IG_Usp__arrow",
  "Usp__description": "_0A3-IG_Usp__description",
  "Usp__image": "_0A3-IG_Usp__image",
  "Usp__title": "_0A3-IG_Usp__title",
  "Usps": "_0A3-IG_Usps",
  "text-center": "_0A3-IG_text-center",
  "text-left": "_0A3-IG_text-left",
  "text-right": "_0A3-IG_text-right",
});
